import { Link } from 'react-router-dom';
import { Badge } from '../ui/badge';

/** Tab "Tickets": elenco ticket del cliente. */
export function TicketsTab({ tickets }) {
  if (tickets.length === 0) {
    return <p className="text-muted-foreground text-sm py-4">Nessun ticket</p>;
  }
  return (
    <div className="border border-border">
      <table className="data-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Oggetto</th>
            <th>Priorità</th>
            <th>Stato</th>
            <th>Data</th>
          </tr>
        </thead>
        <tbody>
          {tickets.map((t) => (
            <tr key={t.id}>
              <td className="font-mono">{t.numero}</td>
              <td>
                <Link to={`/tickets/${t.id}`} className="hover:underline">
                  {t.oggetto}
                </Link>
              </td>
              <td className={`priority-${t.priorita}`}>{t.priorita}</td>
              <td>
                <Badge className={`badge-status badge-${t.stato} rounded-none`}>
                  {t.stato}
                </Badge>
              </td>
              <td className="font-mono text-xs">
                {new Date(t.created_at).toLocaleDateString('it-IT')}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

/** Tab "Documenti": elenco documenti del cliente. */
export function DocumentiTab({ documenti }) {
  if (documenti.length === 0) {
    return <p className="text-muted-foreground text-sm py-4">Nessun documento</p>;
  }
  return (
    <div className="border border-border">
      <table className="data-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Tipo</th>
            <th>Oggetto</th>
            <th>Data</th>
          </tr>
        </thead>
        <tbody>
          {documenti.map((doc) => (
            <tr key={doc.id}>
              <td className="font-mono">{doc.numero}</td>
              <td className="uppercase text-xs font-mono">{doc.tipo}</td>
              <td>{doc.oggetto}</td>
              <td className="font-mono text-xs">
                {new Date(doc.created_at).toLocaleDateString('it-IT')}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
